<template>
  <div class="box">
    <div class="box-heading">
      <setting-icon class="mr-1 text-16"/>生日🎂提醒
    </div>
    <div class="nav flex-column nav-pills">
      <router-link :to="{ name: 'birthday.profile' }" class="nav-link">生日订阅</router-link>
      <router-link :to="{ name: 'birthday.create' }" class="nav-link">新增提醒</router-link>
      <router-link :to="{ name: 'birthday.logs' }" class="nav-link">提醒日志</router-link>
    </div>
  </div>
</template>

<script>
import SettingIcon from '$icons/Settings'

export default {
  components: {
    SettingIcon
  }
}
</script>
